export default "__VITE_ASSET__BifJ3dCQ__"